export const fieldsProps = {
  type: {
    name: 'type',
    placeholder: 'Pilih Jenis Notifikasi',
    label: 'Opsi Tampilan Notifikasi',
    defaultValue: '1',
    required: true,
    data: [
      { label: 'Gambar dan Teks', value: '1' },
      { label: 'Hanya Teks', value: '2' },
      { label: 'Hanya Gambar', value: '3' },
    ]
  },
  title: {
    name: 'title',
    placeholder: 'Masukkan Judul Notifikasi',
    label: 'Judul Notifikasi',
  },
  description: {
    name: 'description',
    placeholder: 'Masukkan ringkasan notifikasi',
    label: 'Ringkasan Notifikasi',
  },
  content: {
    name: 'content',
    placeholder: 'Masukkan Deskripsi Notifikasi',
    label: 'Isi Notifikasi',
  },
  contentImage: {
    name: 'contentImage',
    label: 'Gambar Utama',
    info: 'Ukuran gambar 184px x 328px dengan format .png, .jpg, .jpeg.',
    height: 328,
    width: 184,
  },
  banner: {
    name: 'banner',
    label: 'Gambar Banner',
    info: 'Ukuran gambar 314px x 176px dengan format .png, .jpg, .jpeg',
    height: 176,
    width: 314,
  },
  startDate: {
    name: 'startDate',
    placeholder: 'Pilih Tanggal',
    label: 'Periode Mulai',
    locale: 'id',
    valueFormat: 'DD MMM YYYY',
    required: true,
  },
  endDate: {
    name: 'endDate',
    placeholder: 'Pilih Tanggal',
    locale: 'id',
    valueFormat: 'DD MMM YYYY',
    label: 'Periode Berakhir',
    required: true,
  },
  status: {
    name: 'status',
    label: 'Status',
    defaultValue: 1,
    required: true,
    data: [
      { label: 'Aktif', value: '1' },
      { label: 'Tidak Aktif', value: '2' },
    ]
  }
};
